import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appCardFormate]'
})
export class CardFormateDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInput(event: any) {
    let input = event.target.value;
    // Remove non-numeric characters
    input = input.replace(/\D/g, '');
    // Check if it's a credit card number (16 digits), debit card number (16 or 19 digits), or American Express card (15 digits)
    const isCC = input.length === 16;
    const isDC = input.length === 16 || input.length === 19;
    const isAmex = input.length === 15;
    // If it's a valid card number, add space after every 4 digits
    if (isCC || isDC || isAmex) {
      if (isAmex) {
        input = input.replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3').trim();
      } else {
        input = input.replace(/(\d{4})/g, '$1 ').trim();
      }
    }
    // Update the input value
    event.target.value = input;
  }
}
